import { IPageName } from '../../common/types/apiSchema';
import { PathMap } from './paths';

/**
 * Localised URLs for Hungary
 */
export const HuPaths: PathMap = {
  [IPageName.collections]: ['/:filterslug/szures'],
  [IPageName.instantAccess]: ['/azonnali-hozzaferes/:affiliate'],
};
